(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rx-bike-tools"] && !Shopify.designMode) return;
  try {
    function initRoxformBikeTools(){
  document.querySelectorAll('[data-rx-video-start]').forEach(button=>{
    if(button.dataset.ready)return;button.dataset.ready='true';
    button.addEventListener('click',()=>{const frame=button.parentElement.querySelector('iframe[data-rx-video-src]');if(!frame)return;frame.src=frame.dataset.rxVideoSrc;frame.hidden=false;button.hidden=true;});
  });
  const bar=document.querySelector('[data-rx-compare-bar]');
  if(!bar||bar.dataset.ready)return;bar.dataset.ready='true';
  const dialog=document.querySelector('[data-rx-compare-dialog]');
  const openButton=bar.querySelector('[data-rx-compare-open]');
  const picks=()=>Array.from(document.querySelectorAll('[data-rx-compare-pick]:checked'));
  const sync=()=>{const chosen=picks();bar.querySelector('[data-rx-compare-count]').textContent=chosen.length+'/2';openButton.disabled=chosen.length!==2;document.querySelectorAll('[data-rx-compare-pick]').forEach(input=>{input.disabled=chosen.length===2&&!input.checked;});};
  document.addEventListener('change',event=>{if(event.target.matches('[data-rx-compare-pick]'))sync();});
  openButton.addEventListener('click',()=>{
    const models=picks().map(input=>input.closest('[data-rx-bike-facts]').dataset);if(models.length!==2)return;
    const copy=JSON.parse(bar.dataset.copy);const table=document.createElement('table');
    const row=(label,key,heading=false)=>{const tr=document.createElement('tr');const th=document.createElement('th');th.scope='row';th.textContent=label;tr.append(th);models.forEach(model=>{const td=document.createElement(heading?'th':'td');if(heading)td.scope='col';td.textContent=model[key]||copy.missing;tr.append(td);});table.append(tr);};
    row(copy.model,'title',true);row(copy.price,'price');row(copy.use,'use');row(copy.range,'range');row(copy.weight,'weight');row(copy.stock,'stock');
    const tr=document.createElement('tr');const th=document.createElement('th');th.textContent=copy.details;tr.append(th);models.forEach(model=>{const td=document.createElement('td');const a=document.createElement('a');a.href=model.url;a.textContent=copy.view;td.append(a);tr.append(td);});table.append(tr);
    dialog.querySelector('[data-rx-compare-table]').replaceChildren(table);dialog.showModal();
  });
  dialog.querySelector('[data-rx-compare-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>openButton.focus());sync();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRoxformBikeTools);else initRoxformBikeTools();
document.addEventListener('shopify:section:load',initRoxformBikeTools);
const rxComparisonGrid=document.getElementById('ProductGridContainer');
if(rxComparisonGrid)new MutationObserver(initRoxformBikeTools).observe(rxComparisonGrid,{childList:true,subtree:true});
const rxCtwMarker=document.querySelector('[data-rx-ctw-tracking]');
if(rxCtwMarker?.dataset.enabled==='true'){
  const rxTrack=(eventName,props)=>{
    const privacy=window.Shopify?.customerPrivacy;
    if(!privacy?.analyticsProcessingAllowed?.()||!privacy?.marketingAllowed?.())return;
    if(window.klaviyo?.track)window.klaviyo.track(eventName,props);else{window._learnq=window._learnq||[];window._learnq.push(['track',eventName,props]);}
  };
  const params=new URLSearchParams(location.search);
  let rxContext={FormID:'TVihsm',Bike:params.get('bike')||'',Variant:params.get('variant')||'',Configuration:params.get('configuration')||''};
  let rxStarted=false,rxSubmitted=false,rxStage='';
  document.addEventListener('click',event=>{const link=event.target.closest('a[data-ctw-quote],a[data-mobile-quote]');if(!link)return;const url=new URL(link.href);rxTrack('CTW Quote Link Clicked',{FormID:'TVihsm',Bike:url.searchParams.get('bike')||'',Variant:url.searchParams.get('variant')||'',Configuration:url.searchParams.get('configuration')||'',Placement:link.hasAttribute('data-mobile-quote')?'Mobile purchase bar':'Product page'});});
  document.addEventListener('focusin',event=>{if(!event.target.closest('.klaviyo-form-TVihsm'))return;const label=(event.target.getAttribute('aria-label')||event.target.labels?.[0]?.textContent||event.target.parentElement?.querySelector('label')?.textContent||event.target.getAttribute('name')||'').toLowerCase();rxStage=label.includes('bike')?'Bike selection':label.includes('scheme')?'Scheme provider':label.includes('notes')?'Additional notes':'Contact details';if(!rxStarted){rxStarted=true;rxTrack('CTW Quote Form Started',{...rxContext,Stage:rxStage});}});
  window.addEventListener('klaviyoForms',event=>{const detail=event.detail;if(detail?.formID!=='TVihsm')return;if(detail.type==='open')rxTrack('CTW Quote Form Viewed',rxContext);if(detail.type==='submit'){rxSubmitted=true;const data=detail.metaData||{};rxTrack('CTW Quote Form Submitted',{...rxContext,Bike:data['Bike Model']||rxContext.Bike,SchemeProvider:data['Scheme Provider']||''});}});
  window.addEventListener('pagehide',()=>{if(rxStarted&&!rxSubmitted)rxTrack('CTW Quote Form Left',{...rxContext,LastStage:rxStage});});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rx-cycle-to-work-product"] && !Shopify.designMode) return;
  try {
    function initRoxformCtwProducts(){
  document.querySelectorAll('[data-ctw-product]').forEach(card=>{
    if(card.dataset.ready)return;
    card.dataset.ready='true';
    const variants=JSON.parse(card.querySelector('[data-ctw-variants]').textContent);
    const section=document.getElementById('MainProduct-'+card.dataset.section);
    if(!section)return;
    const bar=card.querySelector('[data-mobile-buy]');
    const mobileButton=bar.querySelector('[data-mobile-submit]');
    const mobilePrice=bar.querySelector('[data-mobile-price]');
    const originalButton=()=>section.querySelector('product-form button[type="submit"]');
    const sync=()=>{
      const button=originalButton();
      const price=section.querySelector('.price__regular .price-item--regular');
      const sale=section.querySelector('.price--on-sale .price__sale .price-item--sale');
      if(sale||price)mobilePrice.textContent=(sale||price).textContent.trim();
      if(button){mobileButton.disabled=button.disabled||button.getAttribute('aria-disabled')==='true';mobileButton.textContent=button.textContent.trim();}
      const nav=document.querySelector('[id^="RxTabbar-"]');
      const navHeight=nav?nav.getBoundingClientRect().height:0;
      document.body.style.setProperty('--rx-mobile-nav',navHeight+'px');
      const rect=button?.getBoundingClientRect();
      const visible=window.matchMedia('(max-width:767px)').matches&&button&&!(rect.top>=0&&rect.bottom<innerHeight-navHeight);
      bar.hidden=!visible;
      document.body.classList.toggle('rx-mobile-buy-active',!!visible);
    };
    mobileButton.addEventListener('click',()=>{const button=originalButton();if(button&&!button.disabled&&button.getAttribute('aria-disabled')!=='true')button.click();});
    let queued=false;
    const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
    const update=()=>{
      const radios=section.querySelector('variant-radios');
      const selects=section.querySelector('variant-selects');
      const options=radios?Array.from(radios.querySelectorAll('fieldset')).map(field=>field.querySelector('input:checked')?.value):selects?Array.from(selects.querySelectorAll('select')).map(select=>select.value):[];
      const variant=options.length?variants.find(item=>item.options.length===options.length&&item.options.every((value,index)=>value===options[index])):variants.find(item=>String(item.id)===section.querySelector('form[action*="/cart/add"] input[name="id"]')?.value)||variants[0];
      const params=new URLSearchParams({bike:card.dataset.title,product:card.dataset.path});
      if(variant){params.set('variant',String(variant.id));if(variant.title!=='Default Title')params.set('configuration',variant.title);}
      const base=card.querySelector('[data-ctw-quote]').getAttribute('href').split('?')[0];
      card.querySelector('[data-ctw-quote]').href=base+'?'+params.toString()+'#ctw-quote';
      card.querySelector('[data-ctw-certificate]').href=base+'?'+params.toString()+'#ctw-certificate';
      bar.querySelector('[data-mobile-quote]').href=base+'?'+params.toString()+'#ctw-quote';
      schedule();
    };
    section.addEventListener('change',update);
    card.addEventListener('click',update);
    const watch=new MutationObserver(schedule);
    const priceTarget=document.getElementById('price-'+card.dataset.section);
    const formTarget=section.querySelector('product-form');
    if(priceTarget)watch.observe(priceTarget,{childList:true,subtree:true,characterData:true,attributes:true});
    if(formTarget)watch.observe(formTarget,{childList:true,subtree:true,characterData:true,attributes:true});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    update();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRoxformCtwProducts);else initRoxformCtwProducts();
document.addEventListener('shopify:section:load',initRoxformCtwProducts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["valor-purchase-options"] && !Shopify.designMode) return;
  try {
    function initRoxformCtwProducts(){
  document.querySelectorAll('[data-ctw-product]').forEach(card=>{
    if(card.dataset.ready)return;
    card.dataset.ready='true';
    const variants=JSON.parse(card.querySelector('[data-ctw-variants]').textContent);
    const section=document.getElementById('MainProduct-'+card.dataset.section);
    if(!section)return;
    const bar=card.querySelector('[data-mobile-buy]');
    const mobileButton=bar.querySelector('[data-mobile-submit]');
    const mobilePrice=bar.querySelector('[data-mobile-price]');
    const originalButton=()=>section.querySelector('product-form button[type="submit"]');
    const sync=()=>{
      const button=originalButton();
      const price=section.querySelector('.price__regular .price-item--regular');
      const sale=section.querySelector('.price--on-sale .price__sale .price-item--sale');
      if(sale||price)mobilePrice.textContent=(sale||price).textContent.trim();
      if(button){mobileButton.disabled=button.disabled||button.getAttribute('aria-disabled')==='true';mobileButton.textContent=button.textContent.trim();}
      const nav=document.querySelector('[id^="RxTabbar-"]');
      const navHeight=nav?nav.getBoundingClientRect().height:0;
      document.body.style.setProperty('--rx-mobile-nav',navHeight+'px');
      const rect=button?.getBoundingClientRect();
      const visible=window.matchMedia('(max-width:767px)').matches&&button&&!(rect.top>=0&&rect.bottom<innerHeight-navHeight);
      bar.hidden=!visible;
      document.body.classList.toggle('rx-mobile-buy-active',!!visible);
    };
    mobileButton.addEventListener('click',()=>{const button=originalButton();if(button&&!button.disabled&&button.getAttribute('aria-disabled')!=='true')button.click();});
    let queued=false;
    const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
    const update=()=>{
      const radios=section.querySelector('variant-radios');
      const selects=section.querySelector('variant-selects');
      const options=radios?Array.from(radios.querySelectorAll('fieldset')).map(field=>field.querySelector('input:checked')?.value):selects?Array.from(selects.querySelectorAll('select')).map(select=>select.value):[];
      const variant=options.length?variants.find(item=>item.options.length===options.length&&item.options.every((value,index)=>value===options[index])):variants.find(item=>String(item.id)===section.querySelector('form[action*="/cart/add"] input[name="id"]')?.value)||variants[0];
      const params=new URLSearchParams({bike:card.dataset.title,product:card.dataset.path});
      if(variant){params.set('variant',String(variant.id));if(variant.title!=='Default Title')params.set('configuration',variant.title);}
      const base=card.querySelector('[data-ctw-quote]').getAttribute('href').split('?')[0];
      card.querySelector('[data-ctw-quote]').href=base+'?'+params.toString()+'#ctw-quote';
      card.querySelector('[data-ctw-certificate]').href=base+'?'+params.toString()+'#ctw-certificate';
      bar.querySelector('[data-mobile-quote]').href=base+'?'+params.toString()+'#ctw-quote';
      schedule();
    };
    section.addEventListener('change',update);
    card.addEventListener('click',update);
    const watch=new MutationObserver(schedule);
    const priceTarget=document.getElementById('price-'+card.dataset.section);
    const formTarget=section.querySelector('product-form');
    if(priceTarget)watch.observe(priceTarget,{childList:true,subtree:true,characterData:true,attributes:true});
    if(formTarget)watch.observe(formTarget,{childList:true,subtree:true,characterData:true,attributes:true});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    update();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRoxformCtwProducts);else initRoxformCtwProducts();
document.addEventListener('shopify:section:load',initRoxformCtwProducts);
  } catch(e) { console.error(e); }
})();

})();
